<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-05-08 14:53:51
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Announcement\components\showDetailReaded.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-16 10:47:48
-->
<template>
  <normalDialog
    :title="$t('label_essweb_Announcement_form_dialog_hasBeenReadLabel')"
    :dialog="show"
    width="800"
    @close="closeDialog"
  >
    <template v-slot:content>
      <v-container fluid class="pa-0 ma-0">
        <v-data-iterator
          :items="desserts"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          @page-count="$tableSetting.pageCount = $event"
          hide-default-footer
          :footer-props="{
            'items-per-page-options': [10, 20, 50],
            'items-per-page-text': $t(
              'label_essweb_list_components_pagenations_perpageLabel'
            ),
          }"
        >
          <template v-slot:no-data>
            <noContent />
          </template>
          <template v-slot:header>
            <v-toolbar
              class="mb-2 px-0 mx-0 d-flex flex-row justify-start"
              flat
            >
              <v-sheet
                class="d-flex flex-row align-center mr-2 ml-n6"
                @click="
                  isAll == 0
                    ? ((curType = 2), (isAll = 1), (isRead = 0), (notRead = 0))
                    : null
                "
              >
                <v-rating
                  v-model="isAll"
                  size="25"
                  readonly
                  class="mx-2"
                  background-color="primary "
                  color="primary"
                  empty-icon="radio_button_unchecked"
                  full-icon="radio_button_checked"
                  :length="1"
                  dense
                />
                {{
                  $t("label_essweb_Announcement_form_dialog_allReadLabel")
                }}({{ totalCount_all }})
              </v-sheet>
              <v-sheet
                class="d-flex flex-row align-center mx-2"
                @click="
                  isRead == 0
                    ? ((curType = 1), (isAll = 0), (isRead = 1), (notRead = 0))
                    : null
                "
              >
                <v-rating
                  v-model="isRead"
                  size="25"
                  readonly
                  class="mx-2"
                  background-color="primary "
                  color="primary"
                  empty-icon="radio_button_unchecked"
                  full-icon="radio_button_checked"
                  :length="1"
                  dense
                />
                {{
                  $t("label_essweb_Announcement_form_dialog_hasReadedLabel")
                }}({{ totalCount_read }})
              </v-sheet>
              <v-sheet
                class="d-flex flex-row align-center mx-2"
                @click="
                  notRead == 0
                    ? ((curType = 0), (isAll = 0), (isRead = 0), (notRead = 1))
                    : null
                "
              >
                <v-rating
                  v-model="notRead"
                  size="25"
                  readonly
                  class="mx-2"
                  background-color="primary "
                  color="primary"
                  empty-icon="radio_button_unchecked"
                  full-icon="radio_button_checked"
                  :length="1"
                  dense
                />
                {{
                  $t("label_essweb_Announcement_form_dialog_notReadLabel")
                }}({{ totalCount_not }})
              </v-sheet>
            </v-toolbar>
          </template>
          <template v-slot:default="props">
            <v-row>
              <v-col
                v-for="item in props.items"
                :key="item.staff_uuid"
                cols="12"
                xm="12"
                sm="6"
                md="6"
                lg="6"
                xl="6"
              >
                <v-card
                  :elevation="0"
                  tile
                  class="mrc-border-solid pa-3 py-0 rounded"
                >
                  <v-list-item dense two-line class="pa-0" v-if="item.staff">
                    <v-list-item-avatar size="36" class="mr-1 my-0">
                      <StaffAvatar
                        size="36"
                        :src="item.staff.staff_avatar"
                        :staff_name="item.staff.preferred_name"
                      />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="table-title text--primary">
                        {{ $getCommonLangValue(item.staff.preferred_name) }}
                        <span class="text--secondary text-caption-xs">
                          {{ item.staff.staff_code }}</span
                        >
                      </v-list-item-title>
                      <v-list-item-subtitle
                        class="table-subtitle text--secondary"
                      >
                        {{ $getCommonLangValue(item.staff.job_post_name) }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <svg-icon
                        size="24"
                        v-if="Number(item.read_flag)"
                        fill="transparent"
                        iconClass="Done"
                      />
                    </v-list-item-action>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
          </template>
          <template v-slot:footer>
            <div>
              <v-divider />
              <v-sheet
                class="
                  pa-2
                  pb-0
                  max-width
                  d-flex
                  flex-nowrap
                  align-center
                  justify-space-between
                "
              >
                <span class="text-caption text--secondary">
                  {{ other }}
                  {{
                    $t("label_essweb_list_components_pagenations_columnLabel")
                  }}({{
                    $t("label_essweb_list_components_pagenations_totalLabel")
                  }}
                  {{ totalCount }}
                  {{
                    $t("label_essweb_list_components_pagenations_columnLabel")
                  }})
                </span>
                <v-spacer></v-spacer>
                <v-pagination
                  v-model="page"
                  color="grey lighten-2 "
                  class="text--primary d-inline-block text-truncate text-center"
                  prev-icon="navigate_before"
                  next-icon="navigate_next"
                  :length="
                    Math.ceil(
                      totalCount /
                        (itemsPerPage == -1 ? totalCount : itemsPerPage)
                    )
                  "
                  :total-visible="7"
                />
                <span class="text-caption text--secondary pr-1">{{
                  $t("label_essweb_list_components_pagenations_perpageLabel")
                }}</span>
                <v-menu offset-y small>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      width="60"
                      height="28"
                      outlined
                      depressed
                      style="
                        border-color: rgba(0, 0, 0, 0.1) !important;
                        border-radius: 6px;
                        min-width: 60px;
                      "
                      class="
                        mrc-border-solid
                        text-capitalize
                        pa-0
                        white
                        text-body-2
                        d-flex
                        justify-space-around
                      "
                      text
                    >
                      {{
                        itemsPerPage == -1
                          ? $t(
                              "label_essweb_list_components_pagenations_selectNumber_allLabel"
                            )
                          : itemsPerPage
                      }}
                      <i class="material-icons-round">arrow_drop_down</i>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      v-for="(item, index) in [10, 20, 50]"
                      :key="index"
                      @click="setPerPage(item)"
                    >
                      <v-list-item-title>{{
                        item == -1
                          ? $t(
                              "label_essweb_list_components_pagenations_selectNumber_allLabel"
                            )
                          : item
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-sheet>
            </div>
          </template>
        </v-data-iterator>
      </v-container>
    </template>
    <!-- actions -->
    <template v-slot:actions>
      <CardActions okBtn :cancelBtn="false" @ok="closeDialog" />
    </template>
    <!-- actions -->
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
import Status from "../../../Ess/Status/Status.vue";

export default {
  components: { Status },
  name: "showDetailReaded",
  props: {
    show: { default: false, type: Boolean },
    curUuid: { default: null, type: [String, Number] },
  },
  computed: {
    totalCount() {
      if (this.isAll) {
        this.curType = 2;
        return this.totalCount_all;
      }
      if (this.isRead) {
        this.curType = 1;

        return this.totalCount_read;
      }
      if (this.notRead) {
        this.curType = 0;

        return this.totalCount_not;
      }
    },
    other() {
      let start =
        this.page == 1
          ? 1
          : Number(this.itemsPerPage) * (Number(this.page) - 1) + 1;
      let end =
        this.page == 1
          ? Number(this.itemsPerPage) * Number(this.page)
          : Number(this.itemsPerPage) * Number(this.page);
      if (Number(end) > Number(this.totalCount)) {
        end = Number(this.totalCount);
      }
      return start + " - " + end;
    },
  },
  watch: {
    page(val) {
      this.getDetail(this.curType, val, this.itemsPerPage);
    },
    curType(val) {
      this.desserts = [];
      this.page = 1;
      this.getDetail(val, 1, this.itemsPerPage);
    },
  },
  data() {
    return {
      desserts: [],
      totalCount_all: 0,
      totalCount_read: 0,
      totalCount_not: 0,
      page: 1,
      notRead: 0,
      itemsPerPage: 0,
      isRead: 0,
      isAll: 1,
      curType: 2,
    };
  },
  mounted() {
    this.itemsPerPage = 10;
    this.getDetail(2, 1, this.itemsPerPage);
    this.getDetail(1, 1, this.itemsPerPage);
    this.getDetail(0, 1, this.itemsPerPage);
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    setPerPage: function (perpage) {
      this.page = 1;
      this.itemsPerPage = perpage;
      this.getDetail(this.curType, 1, perpage);
    },
    onChange: function (page, perPage) {
      this.getDetail(2, page, perPage);
    },
    getDetail: function (read_flag, page, pagesize) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "mrbase_sys_announcement_send",
        url: "/announcement-send/get-list/",
        data: {
          announcement_uuid: this.curUuid,
          read_flag: read_flag,
          cpage: page,
          pagesize: pagesize,
        },
      }).then((res) => {
        if (read_flag == 2) {
          that.totalCount_all = res.totalcount;
        }
        if (read_flag == 1) {
          that.totalCount_read = res.totalcount;
        }
        if (read_flag == 0) {
          that.totalCount_not = res.totalcount;
        }
        that.desserts = res.data;
      });
    },
  },
};
</script>
